import countries from '../../../utils/constants'

function AddFarmerform({ formData, onInputChange, onSelectChange, submittedForm, enterpriseName, farmerResponse }) {
  const handleFarmersubmit = (event) => {
    event.preventDefault();
  }

  return (
    <form onSubmit={handleFarmersubmit}>
      <div
        className='form-grid'
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
        }}
      >
        {/* Name */}
        <div className='mb-3'>
          <label className='form-label required'>Farmer Name</label>
          <input
            type='text'
            name='name'
            className='form-control form-control-solid'
            placeholder='Enter Name'
            value={formData.name}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>

        
        <div className='mb-3'>
          <label className='form-label required'>Country</label>
          {submittedForm ? (
            <input
              type='text'
              name='country'
              className='form-control form-control-solid'
              value={formData.country_name}
              disabled
            />
          ) : (
            <select
              className='form-select form-select-solid'
              value={formData.country_code}
              onChange={(e) => {
                const selectedCountry = countries.find((country) => country.code === e.target.value)
                if (selectedCountry) {
                  onSelectChange('country_code', selectedCountry.code)
                  onSelectChange('country_name', selectedCountry.name)   
                } else {
                  console.log('Selected country not found')
                }
              }}
            >
              <option value='' disabled>
                Select Country
              </option>
              {countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.flag} {country.name}
                </option>
              ))}
            </select>
          )}

        </div>

        <div className='mb-3'>
          {submittedForm ? (
            <>
              <label className='form-label' htmlFor='enterpriseNameInput'>Enterprise Name</label>
              <input
                id='enterpriseNameInput'
                type='text'
                name='company_id'
                className='form-control form-control-solid'
                value={formData.enterprise_name || ''}
                disabled
              />
            </>
          ) : (
            <>
              <label className='form-label required' htmlFor='enterpriseSelect'>Enterprise</label>
              <select
                id='enterpriseSelect'
                className='form-select form-select-solid'
                value={formData.company_id || ''}
                name='company_id'
                onChange={(e) => {
                  const selectedEnterprise = enterpriseName.find(
                    (enterprise) => enterprise.id === parseInt(e.target.value)
                  );
                  if (selectedEnterprise) {
                    onSelectChange('company_id', selectedEnterprise.id);
                    onSelectChange('enterprise_name', selectedEnterprise.name);
                  }
                }}
              >
                <option value='' disabled>
                  Select Enterprise
                </option>
                {enterpriseName?.map((enterprise) => (
                  <option key={enterprise.id} value={enterprise.id}>
                    {enterprise.name}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>


        {/* Source */}
        {submittedForm ? (
          <div className='mb-3'>
            <label className='form-label'>Enterprise Id</label>

            <input
              id='enterpriseNameInput'
              type='text'
              name='company_id'
              className='form-control form-control-solid'
              value={farmerResponse.company_id}
              disabled
            />
          </div>
        ) : (
          <div className='mb-3'>
            <label className='form-label required'>Source</label>
            {submittedForm ? (
              <input
                type='text'
                name='source'
                className='form-control form-control-solid'
                value={formData.source}
                disabled
              />
            ) : (
              <select
                className='form-select form-select-solid'
                value={formData.source}
                onChange={(e) => onSelectChange('source', e.target.value)}
              >
                <option value='' disabled>
                  Select Source
                </option>
                <option value='Web'>Web</option>
                <option value='Mobile'>Mobile</option>
              </select>
            )}
          </div>
        )}
        {submittedForm ? (
          <div className='mb-3'>
            <label className='form-label'>Password</label>

            <input
              type='text'
              name='password'
              className='form-control form-control-solid'
              value={farmerResponse.password}
              disabled
            />
          </div>
        ) : (
          ''
        )}
        {submittedForm && (
          <div className='mb-3'>
            <label className='form-label'>Source</label>
            <input
              type='text'
              name='source'
              className='form-control form-control-solid'
              value={formData.source}
              disabled
            />
          </div>
        )}

        {/* Email */}
        <div className='mb-3'>
          <label className='form-label'>Farmer Email</label>
          <input
            type='email'
            name='email'
            className='form-control form-control-solid'
            placeholder='Enter Email'
            value={formData.email}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>

        {/* Contact Number */}
        <div className='mb-3'>
          <label className='form-label required'>Phone</label>
          <input
            type='text'
            name='ph'
            className='form-control form-control-solid'
            placeholder='Enter Phone Number'
            value={formData.ph}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                onInputChange(e); 
              }
            }}
            disabled={submittedForm}
          />
        </div>

        


      </div>
    </form>
  )
}

export default AddFarmerform
